import React from 'react';
import { Button, Table } from 'react-bootstrap';

interface OrigensTableProps {
    listaOrigens: any[];
    handleNovaOrigem: () => void;
    handleEditarOrigem: (origem: any) => void;
    handleExcluirOrigem: (uuid: string) => void;
    integracaoSelecionada: string;
}

const OrigensTableCard: React.FC<OrigensTableProps> = ({ 
    listaOrigens, handleNovaOrigem, handleEditarOrigem, handleExcluirOrigem, integracaoSelecionada 
}) => {
    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold d-flex justify-content-between align-items-center">
                <span>Origens e Autenticação</span>
                <Button variant="primary" size="sm" onClick={handleNovaOrigem} disabled={!integracaoSelecionada}>
                    + Adicionar Origem
                </Button>
            </div>
            <div className="card-body p-0">
                <Table striped hover className="m-0">
                    <thead>
                        <tr>
                            <th className="ps-3">Nome Origem</th>
                            <th>Tipo</th>
                            <th style={{width: '120px'}} className="text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listaOrigens.length === 0 ? (
                            <tr><td colSpan={3} className="text-center py-3 text-muted">Nenhuma origem configurada. Adicione pelo menos uma.</td></tr>
                        ) : (
                            listaOrigens.map((o: any) => (
                                <tr key={o.uuid}>
                                    <td className="ps-3">{o.nomeOrigem}</td>
                                    <td>{o.tipoOrigemDesc}</td>
                                    <td className="text-center">
                                        <Button variant="outline-primary" size="sm" className="me-2" onClick={() => handleEditarOrigem(o)}>✏️</Button>
                                        <Button variant="outline-danger" size="sm" onClick={() => handleExcluirOrigem(o.uuid)}>🗑️</Button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default OrigensTableCard;